<template>
    <div class="home">
        <Header></Header>
        <Banner></Banner>
        <div class="menu-button-container">
            <MenuButton />
        </div>
        <Gallery></Gallery>
        <Story :title="storyTitle" :description="storyDescription" :images="storyImages" />
        <Story :title="storyTitle1" :description="storyDescription1" :images="storyImages1" />
        <Reviews></Reviews>
        <LocationInfo></LocationInfo>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/homepage/Header'
import Banner from '@/components/homepage/Banner'
import Story from '@/components/homepage/Story'
import Gallery from '@/components/homepage/Gallery'
import LocationInfo from '@/components/homepage/LocationInfo'
import Reviews from '@/components/homepage/Reviews'
import Footer from '@/components/homepage/Footer'
import MenuButton from '@/components/homepage/MenuButton'

export default {
    components: {
        Header,
        Banner,
        Story,
        Gallery,
        LocationInfo,
        Reviews,
        Footer,
        MenuButton,
    },
    data() {
    return {
      storyTitle: 'La tradizione',
      storyDescription: 'Nel cuore della nostra storia gastronomica c\'è lo chef, un maestro culinario la cui vita è intrecciata con la passione per il cibo e l\'amore per la tradizione. Cresciuto tra le cucine della sua famiglia, ha imparato fin da giovane l\'importanza di trasmettere emozioni attraverso i sapori e i profumi delle pietanze preparate con cura e dedizione.',
      storyImages: [
        'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/525739963_18151030987390382_7357381217606812093_n.jpg',
        'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/494527630_1219507680183465_9211075572476833970_n.jpg',
        'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/470194815_1713791819477734_5794427359204310700_n.jpg',
      ],
      storyTitle1: 'Il locale',
      storyDescription1: 'Il nostro locale è un connubio tra tradizione e innovazione culinaria, dove l\'esperienza del nostro chef si unisce alla freschezza degli ingredienti di stagione per offrire piatti unici e indimenticabili. Benvenuti in un luogo dove i sapori incontrano la passione per la cucina di qualità.',
      storyImages1: [
       'http://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/1777738391705-img-20240321-wa0008-65fc0b2c43cd7.webp',
       'https://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/494902132_18142666777390382_57470964802215769_n.jpg',
        'https://ajgw3us0nspzo7gytwy4g381.79.143.179.101.sslip.io/uploads/495334822_1226798932787673_4914345078055331885_n.jpg',
      ]
    };
  }
}
</script>

<style scoped>
.home {
    background-color: var(--background-color);
    text-align: center;
    padding: 0px;
    min-height: 100vh;
    padding-top: 1px;
}

.menu-button-container {
    height: 100px;
    margin-top: 60px;
}
</style>